import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errors: {
      insufficientAmount: 'This amount is too low',
    },
    labels: {
      description: 'Description of expense',
      recipient: 'Beneficiary',
      reseller: 'Reseller',
      supportingDocument: 'Proof',
      totalAmount: 'Expense incl. VAT',
    },
    placeholders: {
      description: 'Describe your expense in more detail...',
      reseller: 'e.g Total, Bricorama, Novotel etc...',
      totalAmount: 'Amount (€)',
    },
    submit: 'Submit',
    supportingDocumentTypes: {
      label:
        'You can only download one document. If you wish to attach several invoices at once, please combine them into a single PDF file.',
    },
    title: 'Upload your receipt',
  },
  fr: {
    errors: {
      insufficientAmount: 'Ce montant est insuffisant',
    },
    labels: {
      description: 'Description de la dépense',
      recipient: 'Bénéficiaire',
      reseller: 'Commerçant',
      supportingDocument: 'Justificatif',
      totalAmount: 'Montant de la dépense TTC',
    },
    placeholders: {
      description: 'Décrivez plus en détails votre dépense...',
      reseller: 'ex : Total, Bricorama, Novotel etc...',
      totalAmount: 'Montant TTC en €',
    },
    submit: 'Confirmer',
    supportingDocumentTypes: {
      label:
        'Vous ne pouvez télécharger qu’un seul document. Si vous souhaitez joindre plusieurs factures en une fois, veuillez les combiner dans un seul fichier PDF.',
    },
    title: 'Téléchargez votre justificatif',
  },
} as const);

export default locales;
